import { render, staticRenderFns } from "./NewVacationTemplate.vue?vue&type=template&id=153efbd2"
import script from "./NewVacationTemplate.vue?vue&type=script&lang=js"
export * from "./NewVacationTemplate.vue?vue&type=script&lang=js"
import style0 from "./NewVacationTemplate.vue?vue&type=style&index=0&id=153efbd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports